const understandingCallerIdAustralia = {
  slug: 'understanding-caller-id-australia',
  title: 'Understanding caller ID in Australia',
  description:
    'How caller identification works in Australia, why numbers can be wrong or spoofed, and what you can trust when an unknown number rings.',
  category: 'guides',
  guideType: 'overview',
  readMinutes: 4,
  partnerTip: 'none',
  relatedSlugs: ['caller-id-spoofing', 'trace-unknown-phone-number', 'future-of-caller-id'],
  sections: [
    {
      type: 'paragraph',
      text: 'Caller ID shows the number (and sometimes a name) associated with an incoming call. In Australia it is useful but not guaranteed to be accurate — especially with VoIP and spoofing.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'How caller ID is delivered',
    },
    {
      type: 'list',
      items: [
        'Your carrier receives signalling data with the call',
        'Mobile networks may show a business name from CNAM-style databases',
        'VoIP and overseas gateways can send arbitrary numbers',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Common issues Australians see',
    },
    {
      type: 'list',
      items: [
        'Spoofed numbers that mimic banks, government, or your own area code',
        '“Unknown” or “Private Number” withholds the caller ID intentionally',
        'Outdated labels when a number is reassigned to a new user',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Regulation in brief',
    },
    {
      type: 'paragraph',
      text: 'Misleading or deceptive conduct using telecommunications is covered by Australian consumer and communications law. ACMA enforces rules around telemarketing and nuisance calls; Scamwatch collects reports on fraud.',
    },
    {
      type: 'link',
      to: '/learn/caller-id-spoofing',
      label: 'Why caller ID can be faked',
    },
    {
      type: 'lookupCta',
    },
  ],
};

export default understandingCallerIdAustralia;
